<template>
  <vs-card>
    <slot/>
  </vs-card>
</template>

<script>
export default {
  name: 'CardWrapper'
}
</script>

<style lang="scss">
.con-vs-card {
  @apply mb-0 h-full;
  .vs-card--content {
    @apply flex flex-col h-full mb-0;
  }
  .con-vs-card {
    @apply mb-0;
  }
}
</style>
